import { z } from 'zod'

export const ticketFeatureFormSchema = z.object({
  featureKey: z
    .string()
    .min(1, 'ticketFeature.validation.featureKeyRequired')
    .regex(/^[a-z_]+$/, 'ticketFeature.validation.featureKeyFormat'),
  localizedData: z.object({
    en: z.object({
      name: z.string().min(1, 'ticketFeature.validation.englishNameRequired'),
      description: z.string().optional(),
    }),
    'vi-south': z.object({
      name: z.string().min(1, 'ticketFeature.validation.vietnameseNameRequired'),
      description: z.string().optional(),
    }),
  }),
})

export type TicketFeatureFormValues = z.infer<typeof ticketFeatureFormSchema>

export const EMPTY_TICKET_FEATURE_FORM_VALUES: TicketFeatureFormValues = {
  featureKey: '',
  localizedData: {
    en: { name: '', description: '' },
    'vi-south': { name: '', description: '' },
  },
}
